import { render, staticRenderFns } from "./column-detail.vue?vue&type=template&id=15ce0174&scoped=true&"
import script from "./column-detail.vue?vue&type=script&lang=ts&"
export * from "./column-detail.vue?vue&type=script&lang=ts&"
import style0 from "./column-detail.vue?vue&type=style&index=0&id=15ce0174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce0174",
  null
  
)

export default component.exports